import React from 'react';
import {Box,Button} from '@material-ui/core'
import IntlMessages from 'util/IntlMessages';
function index(props) {
    return (
        <Box display="flex" p={0} style={{ borderBottom: '1px solid #c4c4c4', margin: '0' }}>
            <Box p={1} flexGrow={1} style={{borderRight: '1px solid #c4c4c4', paddingTop: '0px' }}>
            </Box>
            <Box p={1} style={{ borderRight: '1px solid #c4c4c4', paddingTop: '8px' }}>
                <Button  className={"btn btn-link"}  color={parseInt(props.listNumber)===0?"primary":"default"} 
                component="span"
                onClick={()=>props.checkListNumber(0)}
                ><IntlMessages id="Table.Customer"/></Button>
            </Box>
            <Box p={1} style={{ borderRight: '1px solid #c4c4c4', paddingTop: '8px' }}>
                <Button  className={"btn btn-link"} color={parseInt(props.listNumber)===1?"primary":"default"} 
                component="span"
                onClick={()=>props.checkListNumber(1)}
                >Kontakter</Button>
            </Box>
            <Box p={1} style={{ borderRight: '1px solid #c4c4c4', paddingTop: '8px' }}>
                <Button  className={"btn btn-link"} color={parseInt(props.listNumber)===2?"primary":"default"}
                component="span"
                onClick={()=>props.checkListNumber(2)}
                ><IntlMessages id="Agreement"/></Button>
            </Box>
            <Box p={1} style={{ borderRight: '1px solid #c4c4c4', paddingTop: '8px' }}>
                <Button  className={"btn btn-link"} color={parseInt(props.listNumber)===3?"primary":"default"}
                component="span"
                onClick={()=>props.checkListNumber(3)}
                ><IntlMessages id="Order"/></Button>
            </Box>
            <Box p={1} style={{ borderRight: '1px solid #c4c4c4', paddingTop: '8px' }}>
                <Button  className={"btn btn-link"} color={parseInt(props.listNumber)===4?"primary":"default"}
                component="span"
                disabled
                onClick={()=>props.checkListNumber(4)}
                ><IntlMessages id="DashBoard.Customized.Booking"/></Button>
            </Box>
            <Box p={1} style={{ borderRight: '1px solid #c4c4c4', paddingTop: '8px' }}>
                <Button  className={"btn btn-link"} color={parseInt(props.listNumber)===5?"primary":"default"}
                component="span"
                disabled
                onClick={()=>props.checkListNumber(5)}
                ><IntlMessages id="Activities"/></Button>
            </Box>
            <Box p={1} style={{ borderRight: '1px solid #c4c4c4', paddingTop: '8px' }}>
                <Button  className={"btn btn-link"} color={parseInt(props.listNumber)===6?"primary":"default"}
                component="span"
                disabled
                onClick={()=>props.checkListNumber(6)}
                >Esignering</Button>
            </Box>
            <Box p={1} style={{ paddingTop: '8px' }}>
                <Button  className={"btn btn-link"} color={parseInt(props.listNumber)===7?"primary":"default"}
                component="span"
                disabled
                onClick={()=>props.checkListNumber(7)}
                ><IntlMessages id="DashBoard.Dialer"/></Button>
            </Box>
        </Box>
    );
}

export default index;